import { adminDeleteThematique } from 'admin/store/actions';
import { AdminService } from 'admin/store/service';
import { B64File } from 'common/classes/B64File.class';
import { dispatch } from 'store/store';
/**
 * Thématique du forum
 */
export class Thematique {
    /**
     * Constructeur de la thématique
     * @param thematique à construire
     */
    constructor(thematique) {
        if (thematique) {
            const { idForumThematique, idPere, libelleThematique, file, urlImage, descriptif, dateEnregistrementThematique, actif, ordreThematique, idAuteurSuppression, idRaisonSuppression, dateSuppression, nbMessage, nbDiscussion, children, } = thematique;
            this.idForumThematique = idForumThematique;
            this.idPere = idPere;
            this.libelleThematique = libelleThematique;
            this.file = file ? new B64File(file) : urlImage ? new B64File(B64File.pathUrlToFile(urlImage)) : null;
            this.descriptif = descriptif;
            this.dateEnregistrementThematique = dateEnregistrementThematique;
            this.actif = actif;
            this.ordreThematique = ordreThematique;
            this.idAuteurSuppression = idAuteurSuppression;
            this.idRaisonSuppression = idRaisonSuppression;
            this.dateSuppression = dateSuppression;
            this.children = children === null ? null : children === null || children === void 0 ? void 0 : children.map((child) => new Thematique(child));
            this.nbMessage = nbMessage;
            this.nbDiscussion = nbDiscussion;
        }
    }
    /**
     * Méthode de renvoie de l'objet en back sous la forme d'un tableau
     * @return array
     */
    toRaw() {
        var _a;
        return {
            idForumThematique: this.idForumThematique,
            idPere: this.idPere,
            libelleThematique: this.libelleThematique,
            descriptif: this.descriptif,
            file: (_a = this.file) === null || _a === void 0 ? void 0 : _a.toRaw(),
            dateEnregistrementThematique: this.dateEnregistrementThematique,
            actif: this.actif,
            ordreThematique: this.ordreThematique,
            idAuteurSuppression: this.idAuteurSuppression,
            idRaisonSuppression: this.idRaisonSuppression,
            dateSuppression: this.dateSuppression,
            nbMessage: this.nbMessage,
            nbDiscussion: this.nbDiscussion,
        };
    }
    /**
     * Ajoute ou met à jour une thématique en BDD
     * @return tru si action réussie, false sinon
     */
    save() {
        return AdminService.addForumThematique(this.toRaw());
    }
    /**
     * Supprime une thématique en BDD
     * @return true si action réussie, false sinon
     */
    delete() {
        dispatch(adminDeleteThematique({
            idThematique: this.idForumThematique,
            idAuteurSuppression: this.idAuteurSuppression,
            idRaisonSuppression: this.idRaisonSuppression,
            actif: this.actif,
        }));
    }
}
//# sourceMappingURL=data:application/json;base64,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